import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import LogoutIcon from '@mui/icons-material/Logout';
import Box from '@mui/material/Box';
import { useNavigate, Link } from 'react-router-dom';
import Cookies from 'js-cookie';
import { useCarrito } from '../context/CarritoContext';

const Navbar = () => {
  const nombreDelUsuario = localStorage.getItem('Nombre') + localStorage.getItem('Encargado');
  const navigate = useNavigate();
  const { rol } = useCarrito();

  const handleLogout = () => {
    localStorage.clear();
    localStorage.setItem('Salir', true);
    Cookies.remove('authToken');
    navigate('/login.html');
  };

  const handleCarrito = () => {
    navigate('/carrito.html');
  };

  return (
    <AppBar position="static" sx={{ backgroundColor: '#242c59' }}>
      <Toolbar
        sx={{
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'space-between',
          alignItems: 'center',
          px: 2,
          py: { xs: 1, sm: 0 },
          gap: { xs: 1, sm: 0 },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            gap: { xs: 1, sm: 4 },
            alignItems: 'center',
          }}
        >
          <Typography
            variant="body1"
            component={Link}
            to="/inventario.html"
            sx={{
              color: 'white',
              textDecoration: 'none',
              fontSize: { xs: '14px', sm: '16px' },
            }}
          >
            Inventario
          </Typography>
          <Typography
            variant="body1"
            component={Link}
            to="/pedidos.html"
            sx={{
              color: 'white',
              textDecoration: 'none',
              fontSize: { xs: '14px', sm: '16px' },
            }}
          >
            Pedidos
          </Typography>
          {(rol === 'Administracion' || rol === 'Direccion') && (
            <Typography
              variant="body1"
              component={Link}
              to="/productonegado.html"
              sx={{
                color: 'white',
                textDecoration: 'none',
                fontSize: { xs: '14px', sm: '16px' },
              }}
            >
              Producto Negado
            </Typography>
          )}
          {(rol === 'Administracion' || rol === 'Direccion' || rol === 'gerente') && (
            <Typography
              variant="body1"
              component={Link}
              to="/administracionLago.html"
              sx={{
                color: 'white',
                textDecoration: 'none',
                fontSize: { xs: '14px', sm: '16px' },
              }}
            >
              Administracion
            </Typography>
          )}
          {/*
          (rol === 'Administracion' || rol === 'Direccion') && (
            <Typography
              variant="body1"
              component={Link}
              to="/usuarioslagod.html"
              sx={{
                color: 'white',
                textDecoration: 'none',
                fontSize: { xs: '14px', sm: '16px' },
              }}
            >
              Usuarios
            </Typography>
          )
          */}
        </Box>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            mt: { xs: 1, sm: 0 },
          }}
        >
          <Box
            component="img"
            src="/logo llantas.png"
            alt="Logo"
            sx={{
              height: { xs: 30, sm: 40 },
              width: 'auto',
            }}
          />
          <Typography
            variant="body1"
            sx={{
              color: 'white',
              fontSize: { xs: '14px', sm: '16px' },
              textAlign: 'center',
            }}
          >
            Bienvenido {nombreDelUsuario}
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', gap: 1, mt: { xs: 1, sm: 0 } }}>
          <IconButton color="inherit" onClick={handleCarrito} aria-label="carrito">
            <ShoppingCartIcon />
          </IconButton>
          <IconButton color="inherit" onClick={handleLogout} aria-label="logout">
            <LogoutIcon />
          </IconButton>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
